module.exports = __webpack_public_path__ + "img/italic.511aa4bd.svg";